import { Button, ButtonGroup } from "@blueprintjs/core";

import HeadingView from "common/views/heading/Heading.view";
import PagingView from "common/views/paging/Paging.view";
import { Fragment } from "core/components/FragmentProvider";
import CatalogLabels from "../Catalog.labels";
import * as parentContainerFragments from "./container/parentContainerFragments";
import { ICatalogMetaProps } from "./ICatalogMetaProps";
import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import Label from "core/components/label/Label";
import { useEffect, useState } from "react";
import { BlockView } from "common/views/block/BlockView.view";
import PageSize from "common/fragments/PageSize";
import PageConfig from "panels/page/PageConfig";

// the results list element
export const results: Fragment<ICatalogMetaProps> = {
	name: "Course Results",
	component: ({resultsElement}) => resultsElement // function instead of an element because this gets registered. We need it to update. Remove registration from fragment provider?
};

// title
export const title: Fragment<ICatalogMetaProps> = {
	name: "Title",
	component: () => (
		<HeadingView viewKey="catalog.title" autoSkeleton={false}>
			<CatalogLabels.Labels.PanelTitle />
		</HeadingView>
	)
};

// description
export const description: Fragment<ICatalogMetaProps> = {
	name: "Description",
	component: () => (
		<HeadingView viewKey="catalog.description" autoSkeleton={false}>
			<CatalogLabels.Labels.PanelDescription />
		</HeadingView>
	)
};

// result info "1 of 2 result(s)"
export const resultInfo: Fragment<ICatalogMetaProps> = {
	name: "Result(s) Info",
	component: ({loading, queryMeta: {count, pageNumber, pageSize, total}}) => {

		const start = (pageNumber * pageSize);
		const end = start + count;

		let label: JSX.Element;

		label = (loading && (
			<CatalogLabels.Labels.ResultMetaLoading args={{count, start: start + 1, end: pageSize}} />
		)) || (count > 0 && (
			<CatalogLabels.Labels.ResultMeta args={{start: start + 1, end, total}} />
		));

		return (
			<HeadingView viewKey="catalog.description" autoSkeleton={false}>
				{label || null}
			</HeadingView>
		);
	}
};

// result info "1 of 2 result(s)"
export const containerPicker: Fragment<ICatalogMetaProps> = {
	name: "Container View Select",
	component: ({viewOptions}) => (
		<ButtonGroup>
			{Object.entries(parentContainerFragments).map(([key, fragment]) => (
				<Button key={key} disabled={viewOptions.container === key} onClick={() => viewOptions.setContainer(key)}>
					{fragment.name}
				</Button>
			))}
		</ButtonGroup>
	)
};

export const paging: Fragment<ICatalogMetaProps> = {
	name: "Paging",
	component: ({queryMeta, setParams}) => (
		<PagingView
			viewKey="catalog.paging"
			total={queryMeta.total}
			pageSize={queryMeta.pageSize}
			pageNumber={queryMeta.pageNumber}
			setPageNumber={(pageNumber) => setParams({pageNumber} as any)}
		/>
	)
};

export const loadMore: Fragment<ICatalogMetaProps> = {
	name: "Load More",

	component: ({queryMeta, setParams}) => {
	
		return (
			<ButtonView
					variant={ButtonVariant.PRIMARY}
					viewKey="catalog.loadMore"
					onClick={() => setParams({pageNumber: queryMeta.pageNumber+1})}
				>
					<Label k="catalog.label.loadMore" v="loadMore"/> 
				</ButtonView>
		)
	}
};

export const itemsPerPage: Fragment<ICatalogMetaProps> = {
	name: "Items per page",
	component: ({ params, setParams, queryMeta }) => {
		const handlePageSize = (val) => {
			if(params.pageNumber && Number(params.pageNumber)!== 0) {
				setParams({ pageSize: val, pageNumber: 0 });
			} else {
				setParams({ pageSize: val });
			}
		}
			return (
					<BlockView viewKey="pageSize.block">
						<PageSize
							id={'catalog.pageSize'}
							instance={'courselist'}
							pageSizeOnLoad={params.pageSize ? Number(params.pageSize) : 20}
							searchText={params.query}
							initialPageSize={queryMeta.initialPageSize}
							handlePageSize={handlePageSize}
						/>
					</BlockView>
			);
	}
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/generalFragments.tsx